module.exports = ".sidebar{\n    position: fixed;\n    overflow: hidden;\n}\n\n\n#sidebar-content{\n    width: 107%;\n    height: 100%;\n    overflow-y: scroll;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/client/sidebar/sidebar.component.css
// module id = ./src/app/client/sidebar/sidebar.component.css
// module chunks = main